import { defineMessages } from 'react-intl';

export default defineMessages({
  clearLabel: {
    id: 'neptune.ClearButton.ariaLabel',
    defaultMessage: 'Clear',
    description: 'Description of clear button',
  },
});
